/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card4_TitleInputs */

const tr_landing_web_card4_title = /** @type {(inputs: Landing_Web_Card4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi alan adı, kendi yasal metinleriniz`)
};

const en_landing_web_card4_title = /** @type {(inputs: Landing_Web_Card4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your domain, your legal pages`)
};

const de_landing_web_card4_title = /** @type {(inputs: Landing_Web_Card4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Domain, eigene Rechtstexte`)
};

const ru_landing_web_card4_title = /** @type {(inputs: Landing_Web_Card4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свой домен, свои юридические страницы`)
};

/**
* | output |
* | --- |
* | "Your domain, your legal pages" |
*
* @param {Landing_Web_Card4_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card4_title = /** @type {((inputs?: Landing_Web_Card4_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card4_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card4_title(inputs)
	if (locale === "de") return de_landing_web_card4_title(inputs)
	if (locale === "ru") return ru_landing_web_card4_title(inputs)
	return tr_landing_web_card4_title(inputs)
});